import { ArrowLeft } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import styles from "./StaticPage.module.css";

export default function AboutPage(): JSX.Element {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className={styles.pageWrapper} data-theme={theme}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <button className={styles.backButton} onClick={() => navigate('/home')}>
            <ArrowLeft size={20} /> Back to Home
          </button>
          <div className={styles.logo}>xquant</div>
        </div>
      </nav>

      <main className={styles.content}>
        <h1>About xquant</h1>

        <section>
          <h2>Our Mission</h2>
          <p>
            xquant is building the future of quantitative trading research. We believe that
            powerful trading tools should be accessible to everyone — from individual traders
            exploring their first options strategy to professional quants running complex
            systematic portfolios.
          </p>
        </section>

        <section>
          <h2>What We Do</h2>
          <p>
            We've built an AI-native platform that combines natural language understanding with
            high-performance backtesting infrastructure. Our multi-agent architecture allows you
            to describe trading strategies in plain English, backtest them against years of
            historical data, and iterate rapidly on your ideas.
          </p>
        </section>

        <section>
          <h2>Our Technology</h2>
          <p>
            xquant is powered by a Rust-based backtesting engine for lightning-fast performance,
            QuestDB for time-series data storage, and specialized AI agents that collaborate to
            handle complex trading research workflows. We support stocks, ETFs, and options with
            comprehensive historical data coverage.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Have questions or feedback? We'd love to hear from you. Reach out to us at{' '}
            <a href="mailto:aiquant100@gmail.com">aiquant100@gmail.com</a>
          </p>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>© {new Date().getFullYear()} xquant — All rights reserved.</p>
      </footer>
    </div>
  );
}
